import { Typography, Box, makeStyles } from "@material-ui/core";
import TextField from "./text-field";
export default function Field(props) {
  const { id, label, placeholder, ...rest } = props;
  const cls = fieldStyles();
  return (
    <Box className={cls.container_field}>
      <Typography
        htmlFor={`input-${id}`}
        component="label"
        variant="body2"
        color="textPrimary"
      >
        {label}{" "}
      </Typography>
      <Box className={cls.field}>
        <TextField
          id={`input-${id}`}
          style={{ with: "100%" }}
          placeholder={placeholder}
          {...rest}
        />
      </Box>
    </Box>
  );
}

const fieldStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  container_field: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    width: "100%",
  },
  field: {
    display: "flex",
    alignItems: "stretch",
    position: "relative",
    height: 43,
    "& .MuiInput-root": {
      height: "100% !important",
      boxSizing: "border-box",
      fontSize: "0.8rem",
      "&.Mui-focused": {
        outlineOffset: `-1px `,
        outline: `1px solid ${theme.palette.warning.dark}`,
        border: "none",
      },
    },
    "& input::placeholder": {
      color: theme.palette.grey[600],
    },
  },
}));
